module.exports = __webpack_public_path__ + "img/4.85f8c26b.svg";